import { render, staticRenderFns } from "./RaAvatar.vue?vue&type=template&id=40f043c6&scoped=true"
import script from "./RaAvatar.vue?vue&type=script&lang=js"
export * from "./RaAvatar.vue?vue&type=script&lang=js"
import style0 from "./RaAvatar.vue?vue&type=style&index=0&id=40f043c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f043c6",
  null
  
)

export default component.exports